import { TRANSLATIONS } from "../i18n/translations";
import { getLang } from "../i18n/state";

// Keep this mapping in sync with backend/middleware/auth.ts.
// The DotBots platform only knows about roles, not permissions — each app
// defines its own role → permission mapping. This file mirrors the backend's
// so the UI can hide actions the API would reject anyway.
const ROLE_PERMISSIONS: Record<string, string[]> = {
  admin: [
    "tickets.read", "tickets.write", "tickets.delete",
    "contacts.read", "contacts.write",
    "agents.read", "agents.write",
    "knowledge.read", "knowledge.write", "knowledge.delete",
    "ai.use",
    "settings.read", "settings.write",
  ],
  agent: [
    "tickets.read", "tickets.write",
    "contacts.read", "contacts.write",
    "agents.read",
    "knowledge.read", "knowledge.write",
    "ai.use",
    "settings.read",
  ],
  viewer: [
    "tickets.read", "contacts.read", "agents.read", "knowledge.read",
  ],
};

function tr(key: string): string {
  const dict = TRANSLATIONS[getLang()] ?? TRANSLATIONS.en;
  return dict[key] ?? TRANSLATIONS.en[key] ?? key;
}

export function hasPermission(roles: readonly string[] | undefined, permission: string): boolean {
  if (!roles) return false;
  return roles.some((role) => ROLE_PERMISSIONS[role]?.includes(permission) ?? false);
}

export function roleLabel(role: string): string {
  const key = `role.${role}`;
  const dict = TRANSLATIONS[getLang()] ?? TRANSLATIONS.en;
  if (dict[key]) return dict[key];
  if (TRANSLATIONS.en[key]) return TRANSLATIONS.en[key];
  return role;
}

export function roleLabels(roles: readonly string[] | undefined): string {
  if (!roles || roles.length === 0) return tr("role.none");
  return roles.map(roleLabel).join(", ");
}
